module.exports = __webpack_public_path__ + "img/1552125072.9eff5783.jpg";